import {animate, keyframes, state, style, transition, trigger} from '@angular/animations';

export const searchBarAnimation = trigger('searchBarAnimation', [
  state('true', style({
    width: '25rem',
    opacity: 1
  })),
  state('false', style({
    width: '0px',
    opacity: 0
  })),
  transition('false => true', animate('250ms ease-in-out')),
  transition('true => false', animate('250ms ease-in-out'))
]);
